import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import { getStatusStyle } from "../../utils/utils";
import { styles } from "./styles";
import { EmployeeBannerField } from "../../components/shift/employee-banner-field";

export const EmployeeBanner = ({ selectedMember }: any) => {
    return (
        <Box sx={styles.employeeBannerBody}>
            <Box sx={styles.avatarBox}>
                <Box
                    component="img"
                    sx={styles.bannerIcon}
                    src={selectedMember?.avatar}
                    alt="PROFILE"
                />
            </Box>

            {/* Name and Email */}
            <Box sx={styles.employeeNameBox}>
                <Typography
                    variant="h6"
                    sx={styles.employeeNameText}
                >
                    {selectedMember?.name}
                </Typography>
                <Typography
                    fontSize="12px"
                    variant="body2"
                    color="textSecondary"
                    sx={styles.employeeEmailWordWrap}
                >
                    {selectedMember?.email}
                </Typography>
            </Box>

            {/* Banner Fields */}
            <EmployeeBannerField
                label="Shift Timings"
                value={selectedMember?.timings}
            />
            <EmployeeBannerField
                label="Phone Number"
                value={selectedMember?.phone_number}
            />
            {/* <EmployeeBannerField
                label="Shift Status"
                value={selectedMember?.shift_status}
                color={getStatusStyle(selectedMember?.shift_status).color}
            /> */}
            <EmployeeBannerField
                label="Last Login"
                value={selectedMember?.last_login}
            />
            <EmployeeBannerField
                label="Address"
                value={selectedMember?.address === "" ? "-" : selectedMember?.address}
            />
            <EmployeeBannerField
                label="Shift Type"
                value={selectedMember?.shift_type}
            />
        </Box>
    );
};
